import config from '@plone/volto/registry';
import styles from '../styles.module.css';

const HoneypotField = () => {
  const fieldName = config.settings.honeypotField as string;

  if (!fieldName) return null;

  return (
    <input
      type="text"
      name={fieldName}
      defaultValue=""
      tabIndex={-1}
      autoComplete="off"
      aria-hidden="true"
      className={styles.honeypot}
    />
  );
};

export default HoneypotField;
